/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { arjSettingsFinancialYearResource } from '@jira/router-resources__advanced-roadmaps-settings/src/arjSettingsFinancialYearResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { arjSettingsFinancialYearPageRoute } from '@jira/router-routes__advanced-roadmaps-spa-routes/src/arjSettingsFinancialYearPageRoute.tsx';
import {
	ArjSettingsFinancialYear,
	LazyArjSettingsFinancialYear,
} from './ui/settings/financial-year/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const arjSettingsFinancialYearPageRouteEntry: Route = createEntry(
	arjSettingsFinancialYearPageRoute,
	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: ArjSettingsFinancialYear,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			arjSettingsFinancialYearResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyArjSettingsFinancialYear],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
